setInterval(function () {
  $(".product-slick").each(function (i, obj) {
    if (!$(this).hasClass("slick-slider")) {
      $(this).slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });
}, 1000);

$(document).ready(function () {
  // const activityCheckInterval = setInterval(function () {
  //   if($('#CartDrawer').hasClass('js-drawer-open')){
  //     console.log("ddfdfdf")
  //     $("#agree-terms").prop('checked', false)

  //     // Stop the interval
  //     clearInterval(activityCheckInterval);
  //   }
  // }, 1000); // Check every 1 second

  // Handle checkout button state based on terms agreement
  const updateCheckoutButtonState = (isChecked) => {
    const checkoutButton = $('button[name="checkout"]');
    checkoutButton.prop("disabled", !isChecked);
  };
  $(document).on("change", "#agree-terms", function () {
    updateCheckoutButtonState(this.checked);
  });
  setInterval(function () {
    if ($("#CartDrawer").hasClass("js-drawer-open")) {
      const agreeTerms = $("#agree-terms");
      if (agreeTerms.length > 0) {
        updateCheckoutButtonState(agreeTerms.is(":checked"));
      }
    }
  }, 1000);

  $(document).on("click", ".single_flavor_sel", function (a) {
    var a = $(this).attr("data-val");
    $(".quantity-icon").hide();
    $("." + a).show();
  });

  function applyDiscount(value, discount = 15) {
    // Extract currency symbol (everything non-digit at start or end)
    let match = value.match(/^([^0-9]+)?([\d.,]+)([^0-9]+)?$/);
    if (!match) return value; // return unchanged if format not recognized

    let prefix = match[1] || "";
    let number = match[2];
    let suffix = match[3] || "";

    // Detect decimal separator
    let decimalSeparator = number.indexOf(",") > -1 ? "," : ".";

    // Normalize number (replace , with . if decimal separator is ,)
    let normalized = number.replace(",", ".");
    let price = parseFloat(normalized);

    // Apply discount
    let discounted = price * (1 - discount / 100);

    // Format back with 2 decimals
    let formatted = discounted.toFixed(2);

    // Restore original decimal separator
    if (decimalSeparator === ",") {
      formatted = formatted.replace(".", ",");
    }

    // Reconstruct final value
    return prefix + formatted + suffix;
  }


  // :: START :: section/collection-accordian.liquid
  $(".caccpanel > .caccpanel-heading").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".caccpanel-content").slideUp(200);
      $(".caccpanel > .caccpanel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".caccpanel > .caccpanel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".caccpanel > .caccpanel-heading").removeClass("active");
      $(this).addClass("active");
      $(".caccpanel-content").slideUp(200);
      $(this).siblings(".caccpanel-content").slideDown(200);
    }
  });

  $("ul.tabs > li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs > li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  // :: END :: section/collection-accordian.liquid

  // :: START :: section/advance-featured-collection.liquid
  var $slider = $(".advproduct-v2 > .grid");
  var $progressBar = $(".progress-slide");
  var $progressBarLabel = $(".slider__label");

  $progressBar.css("background-size", "11% 100%").attr("aria-valuenow", 11);

  $progressBarLabel.text("11% completed");

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;
    var calc = eval(calc) + 11;
    if (calc > 96) {
      calc = 100;
    }
    $progressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);

    $progressBarLabel.text(calc + "% completed");
  });

  if (!$slider.hasClass("slick-initialized")) {
    $slider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  $(".advbutton-item .adv-btn").click(function () {
    $(".advbutton-item .adv-btn").removeClass("active");
    var buttonLabel = $(this).attr("data-label");
    if (buttonLabel == "vitality") {
      buttonLabel = "vitalize";
    }
    if (buttonLabel == "bundles") {
      buttonLabel = "multi-formula";
    }

    $(this).addClass("active");
    $(".advproduct-grids.advproduct-v4 .grid-product").hide();
    if ($("body").hasClass("convert__load_024")) {
      $(
        ".advproduct-grids.advproduct-v4 .new_price_pro_grid.grid-product." +
        buttonLabel
      ).show();
    } else {
      $(
        ".advproduct-grids.advproduct-v4 .original_price_pro_grid.grid-product." +
        buttonLabel
      ).show();
    }
    if (buttonLabel == "relax") {
      if ($("body").hasClass("convert__load_024")) {
        $(
          ".advproduct-grids.advproduct-v4 .new_price_pro_grid.grid-product.sleep"
        ).show();
      } else {
        $(
          ".advproduct-grids.advproduct-v4 .original_price_pro_grid.grid-product.sleep"
        ).show();
      }
    }
  });

  // :: END :: section/advance-featured-collection.liquid

  //start timer for landing 1,2,3 pages
  // Let's assume the countdown resets every 24 hours

  var countdownDuration = 24 * 60 * 60 * 1000; // 5 hours in milliseconds
  // Set the initial fixed start time (e.g., the start of the first countdown)
  var fixedStartTime = new Date(Date.UTC(2024, 7, 1, 0, 0, 0)).getTime(); // Example: Aug 1, 2024, at 00:00 UTC

  // Update the countdown every second
  var urlCurrent = window.location.href.split("/");
  var checkPage = urlCurrent[4];
  var pageArr = ["landing-1", "landing-2", "landing-3"];
  if (pageArr.includes(checkPage)) {
    var hrTimer = jQuery(".lh_inner_timelabel").find(".hr__timer");
    var minTimer = jQuery(".lh_inner_timelabel").find(".min__timer");
    var secTimer = jQuery(".lh_inner_timelabel").find(".sec__timer");
    var gtebfcmElement = document.getElementById("gtebfcm");

    setInterval(() => {
      updateCountdown(gtebfcmElement, hrTimer, minTimer, secTimer);
    }, 1000);
    updateCountdown(gtebfcmElement, hrTimer, minTimer, secTimer);
  }

  function updateCountdown(gtebfcmElement, hrTimer, minTimer, secTimer) {
    var nowUTC = new Date().getTime(); // Current time in UTC
    // Calculate the next reset time by adding multiples of the countdown duration to the fixed start time
    var timeSinceStart = nowUTC - fixedStartTime;
    var nextResetTime =
      fixedStartTime +
      Math.ceil(timeSinceStart / countdownDuration) * countdownDuration;
    // Calculate time remaining
    var timeRemaining = Math.floor((nextResetTime - nowUTC) / 1000); // Time remaining in seconds
    // Calculate hours, minutes, and seconds remaining
    var hours = Math.floor(timeRemaining / 3600);
    var minutes = Math.floor((timeRemaining % 3600) / 60);
    var seconds = timeRemaining % 60;
    // Apply new values
    if (hrTimer.length) hrTimer.text(hours);
    if (minTimer.length) minTimer.text(minutes);
    if (secTimer.length) secTimer.text(seconds);
    if (gtebfcmElement) {
      gtebfcmElement.innerHTML = hours + "h " + minutes + "m " + seconds + "s ";
    }
    // If the countdown is complete, reset it
    if (timeRemaining <= 0) {
      nextResetTime = fixedStartTime + countdownDuration;
    }
  }

  /* HOW TO USE SLIDER -- START */

  $(".how_use_slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1.7,
    slidesToScroll: 1,
  });

  /*
  $(document).ready(function () {
    let productTitle = $('#product_title').val();
    
    setInterval(function(){
      if($('.sub-radio-cust').length == 0){
        $('.rc_widget__option--subsave').addClass('sub-radio-cust');
        var onetimeRadio = jQuery(".rc_widget__price--subsave").html();
        if (typeof onetimeRadio === "undefined") {
        }
        else{
          console.log("--->", onetimeRadio)
          // Extract the currency symbol (first non-numeric character)
          var currencySymbol = onetimeRadio.match(/[^\d.,]+/)[0];
          
          // Extract the numeric price (remove the currency symbol)
          var priceValue = parseFloat(onetimeRadio.replace(/[^\d.,]/g, ''));
  
          if(productTitle == 'gaming diffuser' || 
              productTitle == 'vitamin b-12 diffuser' || 
              productTitle == 'calm diffuser' || 
              productTitle == 'caffeine diffuser' ||  
              productTitle == 'mullein diffuser' ||  
              productTitle == 'melatonin diffuser'
          ){
             // Calculate the 15% discount
            var discount = priceValue * 0.15; 
          }
          else{
            // Calculate the 25% discount
            var discount = priceValue * 0.25;
          }
          var newPrice = priceValue - discount;
          $('.rc_widget__price--subsave').html(currencySymbol+newPrice.toFixed(2));
          //var newonetimeprice = eval(onetimeRadio
          //console.log("--->", ontimeRadioArr)
          //jQuery(".rc-radio.onetime-radio .rc-radio__label").html(ontimeRadioArr[0] +' '+ontimeRadioArr[1] + '<span>'+ontimeRadioArr[2]+'</span>');
        }
      }
      if($('.onetime-radio-cust').length == 0){
        $('.rc_widget__option--onetime').addClass('onetime-radio-cust');
        var onetimeRadio = jQuery(".rc_widget__price--onetime").html();
        if (typeof onetimeRadio === "undefined") {
        }
        else{
          console.log("--->", onetimeRadio)
          // Extract the currency symbol (first non-numeric character)
          var currencySymbol = onetimeRadio.match(/[^\d.,]+/)[0];
          
          // Extract the numeric price (remove the currency symbol)
          var priceValue = parseFloat(onetimeRadio.replace(/[^\d.,]/g, ''));
  
          if(productTitle == 'gaming diffuser' || 
              productTitle == 'vitamin b-12 diffuser' || 
              productTitle == 'calm diffuser' || 
              productTitle == 'caffeine diffuser' ||  
              productTitle == 'mullein diffuser' ||  
              productTitle == 'melatonin diffuser'
          ){
             // Calculate the 15% discount
            var discount = priceValue * 0.15; 
          }
          else{
            // Calculate the 25% discount
            var discount = priceValue * 0.25;
          }
          var newPrice = priceValue - discount;
          $('.rc_widget__price--onetime').html(currencySymbol+newPrice.toFixed(2));
          //var newonetimeprice = eval(onetimeRadio
          //console.log("--->", ontimeRadioArr)
          //jQuery(".rc-radio.onetime-radio .rc-radio__label").html(ontimeRadioArr[0] +' '+ontimeRadioArr[1] + '<span>'+ontimeRadioArr[2]+'</span>');
        }
      }
    },1000);
  });
  */

  if ($("body").hasClass("convert__load")) {
    // Get the current URL
    var currentUrl = window.location.href;

    // Check if the URL contains '/products'
    if (currentUrl.indexOf("/products") !== -1) {
      // Check if the URL contains 'completeset'
      if (currentUrl.indexOf("completeset") !== -1) {
        // Redirect to 'b-completeset'
        window.location.href = "/products/b-completeset";
      }
      if (currentUrl.indexOf("gaming-diffuser") !== -1) {
        window.location.href = "/products/b-gaming-diffuser";
      }
      if (currentUrl.indexOf("vitaminb12") !== -1) {
        window.location.href = "/products/b-vitaminb12";
      }
      if (currentUrl.indexOf("calming-diffuser") !== -1) {
        window.location.href = "/products/b-calming-diffuser";
      }
      if (currentUrl.indexOf("caffeinediffuser") !== -1) {
        window.location.href = "/products/b-caffeinediffuser";
      }
      if (currentUrl.indexOf("lung-reset-diffuser") !== -1) {
        window.location.href = "/products/b-lung-reset-diffuser";
      }
      if (currentUrl.indexOf("melatonin-diffuser") !== -1) {
        window.location.href = "/products/b-melatonin-diffuser";
      }
    }
  }

  // RECHARGE INNER CONTENT -- START

  setTimeout(function () {
    var valueOption = jQuery(
      ".rc-template__radio-group .rc_widget__option__input:checked"
    ).val();
    subscirbeHtml(valueOption);
  }, 1000);

  setInterval(function () {
    var isRechargeV1 = jQuery(".recharge__v1").length > 0;
    var isRechargeV2 = jQuery(".recharge__v2").length > 0;
    var isRechargeV3 = jQuery(".recharge__v3").length > 0;
    var isRechargeV4 = jQuery(".recharge__v4").length > 0;
    var discountStr = jQuery(".rc_widget__option__discount").text();

    if (isRechargeV1) {
      var subSaveStr = "Subscribe & <span>Save " + discountStr + "</span>";
      jQuery(".rc-option__subsave")
        .find(".rc_widget__option__label")
        .find(".rc-option__text")
        .html(subSaveStr);
      jQuery(".rc_widget__option__discount").hide();
    }
    if (isRechargeV2) {
      var subSaveStr = "Subscribe <span>Save " + discountStr + "</span>";
      jQuery(".rc-option__subsave")
        .find(".rc_widget__option__label")
        .find(".rc-option__text")
        .html(subSaveStr);
      jQuery(".rc_widget__option__discount").hide();
    }
    if (isRechargeV3) {
      var subSaveStr = "Subscribe <span>Save " + discountStr + "</span>";
      jQuery(".rc-option__subsave")
        .find(".rc_widget__option__label")
        .find(".rc-option__text")
        .html(subSaveStr);
      jQuery(".rc_widget__option__discount").hide();
    }
    if (isRechargeV4) {
      // Check if switch_with_usps doesn't exist before appending
      if (jQuery(".switch_with_usps").length == 0) {
        jQuery(".rc-widget-injection-parent .rc-radio-group__options").append(
          '<div class="switch_with_usps"><div class="switch_box"><img class="switch_img" src="https://cdn.shopify.com/s/files/1/0623/4485/5760/files/tabler_hand-click.png?v=1733208224"><div class="switch_content"><h6>Switch to Subscription and SAVE ' +
          discountStr +
          '</h6><p>Pause, update frequency or cancel anytime.</p></div></div><ul class="subsave-usps"> <li>Save an EXTRA ' +
          discountStr +
          " OFF</li> <li>Unlock FREE Shipping</li> <li>No commitment, cancel anytime</li> </ul></div>"
        );
      }

      jQuery(".rc-option__onetime")
        .find(".rc_widget__option__label")
        .find(".rc-option__text")
        .html("One-time");
      var subSaveStr = "Subscribe <span>(Save " + discountStr + ")</span>";
      jQuery(".rc-option__subsave")
        .find(".rc_widget__option__label")
        .find(".rc-option__text")
        .html(subSaveStr);
      jQuery(".rc_widget__option__discount").hide();
    }
  }, 500);

  jQuery(document).on(
    "change",
    ".rc-template__radio-group .rc_widget__option__input",
    function () {
      var valueOption = jQuery(this).val();
      subscirbeHtml(valueOption);
    }
  );

  function subscirbeHtml(val) {
    if (val == "subsave") {
      var discountStr = jQuery(".rc_widget__option__discount").text();
      var parentSelector = $(".rc-widget-injection-parent");

      if (parentSelector.length !== 0) {
        var subsaveUspsList =
          '<ul class="subsave-usps"> <li>Save an EXTRA ' +
          discountStr +
          " OFF</li> <li>Unlock FREE Shipping</li> <li>No commitment, cancel anytime</li> </ul>";

        jQuery(".subsave-usps").remove();
        jQuery(".rc-widget-injection-parent .rc-option__subsave").append(
          subsaveUspsList
        );
        jQuery(".switch_with_usps").remove();
        jQuery(".rc-widget-injection-parent .rc-radio-group__options").append(
          '<div class="switch_with_usps"><div class="switch_box"><img class="switch_img" src="https://cdn.shopify.com/s/files/1/0623/4485/5760/files/tabler_hand-click.png?v=1733208224"><div class="switch_content"><h6>Switch to Subscription and SAVE ' +
          discountStr +
          "</h6><p>Pause, update frequency or cancel anytime.</p></div></div>" +
          subsaveUspsList +
          "</div>"
        );
      }
    }
  }

  // jQuery('.recharge__v4 .rc_container_wrapper .rc-option__onetime').click(function(){
  jQuery(document).on(
    "click",
    ".recharge__v4 .rc-option__onetime",
    function () {
      // jQuery('.switch_with_usps').show();
      // jQuery('.switch_box').show();
      // jQuery('.subsave-usps').hide();
      jQuery(".rc-radio-group__options").addClass("rc_onetime_open");
      jQuery(".rc-radio-group__options").removeClass("rc_subsave_open");
    }
  );
  // jQuery('.recharge__v4 .rc_container_wrapper .rc-option__subsave').click(function(){
  jQuery(document).on(
    "click",
    ".recharge__v4 .rc-option__subsave",
    function () {
      // jQuery('.switch_with_usps').show();
      // jQuery('.switch_box').hide();
      // jQuery('.subsave-usps').show();
      jQuery(".rc-radio-group__options").addClass("rc_subsave_open");
      jQuery(".rc-radio-group__options").removeClass("rc_onetime_open");
    }
  );
  jQuery(document).on(
    "click",
    ".collection-offer-popup .banner-popup-btn",
    function () {
      jQuery(this).addClass("redeem_code_active");
    }
  );
  jQuery(document).on(
    "click",
    ".collection-offer-popup .banner-popup-btn",
    function () {
      jQuery(this).addClass("redeem_code_active");
      setTimeout(function () {
        jQuery(".cb-popup-overlay").trigger("click");
      }, 2000);
    }
  );
  jQuery(document).on("click", ".cb-popup-overlay", function () {
    jQuery(".collection-offer-popup").attr("class", "collection-offer-popup");

    jQuery(document).on(
      "click",
      ".collection-offer-popup .banner-popup-btn",
      function () {
        jQuery(this).addClass("redeem_code_active");
        setTimeout(function () {
          jQuery(".cb-popup-overlay").trigger("click");
        }, 2000);
      }
    );

    // Restore scrolling
    jQuery("body").css("overflow", "auto");
  });

  // RECHARGE INNER CONTENT -- END

  // PRODUCT DETEIALS PAGE FOR SUBSCRIPTION CHANGE EVENT JS START
  jQuery(document).on("change", "[name='purchaseOption']", function () {
    subscribeText(jQuery(this).val());
  });
  var interSub = setInterval(function () {
    if (jQuery(".rc-widget").find('[name="purchaseOption"]').length > 0) {
      var getopt = jQuery(".rc-widget")
        .find("[name='purchaseOption']:checked")
        .val();
      subscribeText(getopt);
      clearInterval(interSub);
    }
  });
  function subscribeText(text) {
    const oneTimeClass = "one-time-cls";
    const subscribeClass = "subscribe-cls";
    const $subscriptionDetails = jQuery(".rc-widget .rc-subscription-details");

    if (text === "subscription") {
      $subscriptionDetails.addClass(subscribeClass).removeClass(oneTimeClass);
    } else {
      $subscriptionDetails.addClass(oneTimeClass).removeClass(subscribeClass);
    }
  }
  // PRODUCT DETEIALS PAGE FOR SUBSCRIPTION CHANGE EVENT JS END
});
